import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

import Button from "../Button";
import Modal from "../Modal";
import StatusImage from "../StatusImage";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
`;
const Message = styled.div`
  font-size: 18px;
  text-align: center;
  margin-top: 48px;
`;
const ExtraMessage = styled.div`
  color: ${Style.palette.grayscale[4]};
  margin: 11px 0 48px 0;
  text-align: center;
`;
const Buttons = styled.div<{ centered?: boolean }>`
  display: flex;
  justify-content: ${props => (props.centered ? "center" : "space-between")};
  width: 100%;
`;

type AlertType = "error" | "confirmation" | "loading";
type Props = {
  title: string;
  message: string;
  extraMessage: string;
  type?: AlertType;
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirmation: () => void;
};
@observer
class AlertModal extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    type: "confirmation",
  };

  id: string | null = null;

  renderDismissButton() {
    if (this.props.type !== "error") {
      return null;
    }

    return (
      <Buttons centered>
        <Button secondary onClick={this.props.onRequestClose}>
          Dismiss
        </Button>
      </Buttons>
    );
  }

  renderConfirmationButtons() {
    if (this.props.type !== "confirmation") {
      return null;
    }

    return (
      <Buttons>
        <Button secondary onClick={this.props.onRequestClose}>
          No
        </Button>
        <Button onClick={this.props.onConfirmation}>Yes</Button>
      </Buttons>
    );
  }

  render() {
    const status =
      this.props.type === "loading"
        ? "RUNNING"
        : this.props.type || "confirmation";

    return (
      <Modal {...this.props}>
        <Wrapper>
          {<StatusImage status={status} />}
          {this.props.message ? <Message>{this.props.message}</Message> : null}
          {this.props.extraMessage ? (
            <ExtraMessage>{this.props.extraMessage}</ExtraMessage>
          ) : null}
          {this.renderConfirmationButtons()}
          {this.renderDismissButton()}
        </Wrapper>
      </Modal>
    );
  }
}

export default AlertModal;
